// uniqueKey = (workPackage.id)_work.id_technologicalOperation.id_technologicalOperation.index_workResultsType.id_resultValue.id

export function parseUniqueKey (uniqueKey) {
  let [
    workPackageId = null,
    workId = null,
    operationId = null,
    technologicalOperationIndex = null,
    workResultId = null,
    resultValueId = null
  ] = uniqueKey.split('_')

  workPackageId = workPackageId || null // может быть ''

  return {
    // workPackageId
    workId,
    operationId,
    // technologicalOperationIndex
    workResultId
    // resultValueId
  }
}
